export default "__VITE_ASSET__CwIj2SZq__"